import { addDataLayerEvent } from "../../../../../../utils/data.layer.utils/data.layer.util";
import { motion } from "framer-motion";
import { useCallback } from "react";
import { Icon } from "../../../../Icons/generic";

const ProductViewDownloadButton = ({ button, trackingVals }) => {
	const onClick = useCallback(() => {
		addDataLayerEvent('CallToActionEventDownloadButton', trackingVals);
	}, [trackingVals]);

	return (
		<a
			title={button.title}
			href={button.asset.url}
			target="_blank"
			download
			onClick={onClick}
		>
			<motion.div
				className="tool valign-wrapper"
				whileHover={{
					scale: 1.02,
					transition: {
						duration: .02,
					}
				}}
				whileTap={{
					scale: 1,
					transition: {
						duration: .1
					}
				}}
			>
				<Icon
					icon={{
						icon: button.icon.icon,
						type: button.icon.type,
						size: "sm"
					}}
					fixedWidth
				/>
			</motion.div>
			<p className="title">{button.title}</p>
		</a>
	);
};

export {
	ProductViewDownloadButton
};